import { Component, ElementRef, ViewChild } from '@angular/core';
import { WidgetLine } from '@wizeoo/akm-compute-lib';
import { WizRoot, WizEventManager } from '@wizeoo/akm-component-lib';
import { ICellRenderer, ICellRendererParams } from 'ag-grid-community';
import { Pivot } from '../../pivot.component';
import { AlkEvent } from '../../../../../framework/events/alk.event';
import { ALK_EVENT_TYPE } from '../../../../../model/enums';

@Component({
  selector: 'pivot-incexc-renderer',
  template: `
    <wiz-hgroup width="100%" height="100%" verticalAlign="center" [visible]="!isEmptyCell">
      <span #block width="1px"></span>
      <wiz-icon (click)="generateInclude()">play</wiz-icon>
      <wiz-icon (click)="generateExclude()">cancel</wiz-icon>
    </wiz-hgroup>
  `,
})
export class PivotIncExcRenderer implements ICellRenderer {
  @ViewChild('block') block: ElementRef;

  public pivot: Pivot; // accesseur sur le pivot
  private rowLine: WidgetLine; // la widgetLine de base pour cette ligne. Ce n'est pas forcément la bonne ligne pour la colonne...
  public params: any;
  public column: any;

  public realLine: WidgetLine = null; // une ligne qui représente VRAIMENT la valeur de cette cellule (mode pivot)
  public linePack: WidgetLine[]; // le pool de lignes qui correspondent à ma cellule
  public isEmptyCell: boolean = false; // pas de données pour cet aggrégat

  // gets called once before the renderer is used
  agInit(params: any): void {
    // console.log('params', params);
    this.pivot = params.colDef.widget;
    this.params = params;
    this.column = params.column;
    this.rowLine = params.data;

    if (this.pivot.pivotMode) {
      // identifier le pool de lignes, et définir ma ligne "référence"

      this.linePack = this.pivot.getPool(this.rowLine, this.column);
      if (this.linePack && this.linePack.length > 0) {
        this.realLine = this.linePack[0]; // on affecte le témoin
      }
    } else {
      // en mode simple, pas d'ambiguité
      this.realLine = this.rowLine;
      this.linePack = [this.rowLine];
    }

    this.isEmptyCell = this.linePack.length <= 0;
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams): false {
    this.isEmptyCell = this.linePack.length <= 0;
    return false;
  }

  generateInclude() {
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.INC_EXC_FAST_INC, this));
  }

  generateExclude() {
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.INC_EXC_FAST_EXC, this));
  }

  getValueToDisplay(params: ICellRendererParams) {
    return '';
  }
}
